/**
 * @generated SignedSource<<74dc89808b45206bc53502b3ae91790c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentSessionSnapshot_session$data = {
  readonly agent: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null;
  readonly agentAccountId: string | null;
  readonly associatedEntities: ReadonlyArray<{
    readonly __typename: "ConfluencePage";
    readonly id: string;
    readonly links: {
      readonly base: string | null;
      readonly webUi: string | null;
    } | null;
    readonly title: string | null;
  } | {
    readonly __typename: "JiraIssue";
    readonly id: string;
    readonly key: string;
    readonly webUrl: AGG$URL | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null> | null;
  readonly author: {
    readonly accountId: string;
    readonly name: string;
  } | null;
  readonly conversationChannel: {
    readonly createdAt: AGG$Long | null;
    readonly id: string | null;
    readonly interactionChannel: string | null;
    readonly interactionChannelAri: string | null;
    readonly isPinned: boolean | null;
    readonly isPlanning: boolean | null;
    readonly lastAgentMessageId: string | null;
    readonly lastAgentMessageStatus: string | null;
    readonly lastMessage: string | null;
    readonly lastMessageTimestamp: AGG$Long | null;
    readonly lastMessageType: ReadonlyArray<string | null> | null;
    readonly name: string | null;
    readonly pinnedAt: AGG$Long | null;
    readonly readStatus: boolean | null;
    readonly status: string | null;
  } | null;
  readonly convoAiAgentId: string | null;
  readonly expireTime: AGG$DateTime | null;
  readonly id: string | null;
  readonly isRovo: boolean | null;
  readonly lastStateChangeAt: AGG$Long | null;
  readonly state: string | null;
  readonly stateReason: string | null;
  readonly studioAgent: {
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "agentSessionSnapshot_session";
};
export type agentSessionSnapshot_session$key = {
  readonly " $data"?: agentSessionSnapshot_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentSessionSnapshot_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
},
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "agentSessionSnapshot_session",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "state"
    },
    {
      "kind": "ScalarField",
      "name": "stateReason"
    },
    {
      "kind": "ScalarField",
      "name": "expireTime"
    },
    {
      "kind": "ScalarField",
      "name": "lastStateChangeAt"
    },
    {
      "kind": "ScalarField",
      "name": "isRovo"
    },
    {
      "kind": "ScalarField",
      "name": "agentAccountId"
    },
    {
      "kind": "ScalarField",
      "name": "convoAiAgentId"
    },
    {
      "alias": "conversationChannel",
      "concreteType": "AgentConversationChannel",
      "kind": "LinkedField",
      "name": "nativeConversationChannel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "interactionChannel"
        },
        {
          "kind": "ScalarField",
          "name": "interactionChannelAri"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "lastMessage"
        },
        {
          "kind": "ScalarField",
          "name": "lastMessageTimestamp"
        },
        {
          "kind": "ScalarField",
          "name": "lastMessageType"
        },
        {
          "kind": "ScalarField",
          "name": "lastAgentMessageId"
        },
        {
          "kind": "ScalarField",
          "name": "lastAgentMessageStatus"
        },
        {
          "kind": "ScalarField",
          "name": "readStatus"
        },
        {
          "kind": "ScalarField",
          "name": "isPlanning"
        },
        {
          "kind": "ScalarField",
          "name": "isPinned"
        },
        {
          "kind": "ScalarField",
          "name": "pinnedAt"
        },
        {
          "kind": "ScalarField",
          "name": "status"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "agent",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v1/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "name": "studioAgent",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "name": "associatedEntities",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "webUrl"
            }
          ],
          "type": "JiraIssue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "title"
            },
            {
              "concreteType": "ConfluencePageLinks",
              "kind": "LinkedField",
              "name": "links",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "base"
                },
                {
                  "kind": "ScalarField",
                  "name": "webUi"
                }
              ]
            }
          ],
          "type": "ConfluencePage"
        }
      ]
    }
  ],
  "type": "AgentSession"
};
})();

(node as any).hash = "2fb6771ae9ea80113fe7a85213c6df27";

export default node;
